<script>
    import GoogleMap from '@/components/google-map';
    export default {
        props: ['data'],
        components: {
            GoogleMap,
        },
        data () {
            return {
                
            }
        }
    };
</script>
<template>
    <div class="page-wrapper section-space--inner--120">
        <!--Contact section start-->
        <div class="conact-section">
            <div class="container">

                <div class="row section-space--bottom--50">
                    <div class="col">
                        <!-- google map component -->
                        <GoogleMap />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 col-12">
                        <div class="contact-information">
                            <h3>Informasi Kontak</h3>
                            <p class="font-size-18 mb-4"><span><i class="fa fa-address-book mr-2"></i></span>{{data.address.body}}</p>
                            <p class="font-size-18 mb-4"><span><i class="fa fa-phone mr-2"></i></span>{{data.phone.body}}</p>
                            <p class="font-size-18 mb-4"><span><i class="fa fa-envelope mr-2"></i></span>{{data.email.body}}</p>
                        </div>
                    </div>
                    <div class="col-lg-8 col-12">
                        <div class="contact-form-green">
                            <h3>Tinggalkan Pesan</h3>
                            <form id="contact-form">
                                <div class="row row-10">
                                    <div class="col-md-6 col-12 section-space--bottom--20">
                                        <input name="con_name" type="text" placeholder="Nama Anda">
                                    </div>
                                    <div class="col-md-6 col-12 section-space--bottom--20">
                                        <input name="con_email" type="email" placeholder="Email">
                                    </div>
                                    <div class="col-12">
                                        <textarea name="con_message" placeholder="Ketikkan Pesan.."></textarea>
                                    </div>
                                    <div class="col-12">
                                        <button>Kirim Pesan</button>
                                    </div>
                                </div>
                            </form>
                            <p class="form-message"></p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <!--Contact section end-->
    </div>
</template>
